// AUTO-GENERATED by scripts/generate-build-info.mjs at build time. Do not edit.
export const BUILD_ID = '1793633135990';
